/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const createEntitiesItemNewStyles = makeStyles(theme => ({
  card: {
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px',
    border: '1px solid #EEE',
    borderRadius: '12px',
    width: '280px',
    minHeight: '153px',
    height: '100%',
    transition: 'box-shadow 0.2s linear',

    '&:hover': {
      boxShadow: '0px 0px 0px 1px #EEEEEE inset',
    },
  },
  cardTitle: {
    fontWeight: 500,
    textTransform: 'uppercase',
  },
  cardDisabled: {
    cursor: 'default',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  cardTitleDisabled: {
    color: theme.palette.graphicElements.main,
  },
}));
